/* global process */
let base = window._env_.VUE_APP_FIN_CENTER_HOST
export const getCustomerReceiptTable = params => {
  return axios.post(`${base}/receipt-applications/receipt_info/lists`, params)
}
// 远程搜索使用的接口，支持 抬头名称/抬头ID 搜索
export const receiptInfoForRemoteSearch = params => {
  return axios.post(`${base}/receipt-applications/receipt_info/query_for_search`, params)
}

export const getCustomerReceiptDetail = params => {
  return axios.get(`${base}/receipt-applications/receipt_info/${params.id}`, {params})
}
export const exportCustomerReceiptData = params => {
  return axios.get(`${base}/exportCustomerReceiptData/${params.id}`, {params})
}
export const createCustomerReceiptData = params => {
  return axios.post(`${base}/receipt-applications/receipt_info/create`, params)
}
export const updateReceiptInfoData = params => {
  return axios.post(`${base}/receipt-applications/receipt_info/${params.id}/edit`, params)
}
export const deleteCustomerReceiptData = params => {
  return axios.post(`${base}/deleteCustomerReceiptData/${params.id}`, params)
}

export const exportCustomerReceiptTable = params => {
  return axios.post(`${base}/receipt-applications/receipt_info/export`, params)
}

export const uploadCustomerReceiptAttachedFile = params => {
  return axios.post(`${base}/receipt-applications/receipt_info/upload`, params)
}

export const enableCustomerReceipt = params => {
  return axios.post(`${base}/receipt-applications/receipt_info/${params.id}/enable`, params)
}

export const disableCustomerReceipt = params => {
  return axios.post(`${base}/receipt-applications/receipt_info/${params.id}/disable`, params)
}

export const getCustomerTableForSearch = params => {
  return axios.post(`${base}/forward/customer`, params)
}



// WEBPACK FOOTER //
// ./src/views/customer-receipt/customer-receipt.api.js